module.exports = __webpack_public_path__ + "static/media/step-two-small.cb4b6f0c.jpg";